import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import styles from "./customTable.module.scss";

export default function CustomTable({ columns, rows = [], page, rowsPerPage, rowId }) {
    return (
        <Paper sx={{ width: '100%', overflow: 'hidden', boxShadow: "unset", bgColor: '#E5E5E5', marginTop: "10px" }}>
            <TableContainer className={styles.tableContainer} sx={{ bgColor: '#E5E5E5' }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow classes={{ root: styles.row, head: styles.rowHeaders }}>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row) => {
                                return (
                                    <TableRow classes={{ root: styles.row }} hover tabIndex={-1} key={row[rowId]}>
                                        {columns.map((column) => {
                                            const value = row[column.id];
                                            return (
                                                <TableCell key={column.id} align={column.align}>
                                                    {column.format && typeof value === 'number'
                                                        ? column.format(value)
                                                        : value}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
}
